import { get, post, put, putStatus } from "src/api/deal-setting";
import DealActivityLogsDrawer from "src/modules/deal/components/DealActivityLogsDrawer.vue";

import DealSettingForm from "src/modules/deal/components/DealSettingForm.vue";

const getInitialState = () => {
  return {
    dealSettings: [],
    dealSetting: {},
  };
};

export const useDealSettingStore = defineStore("deal-setting", () => {
  const { state: dealSettingFormState, toggle: toggleDealSettingForm } =
    useDrawer({
      component: DealSettingForm,
    });

  const { toggle: toggleActivityLogsDrawer } = useDrawer({
    component: DealActivityLogsDrawer,
  });
  const state = reactive(getInitialState());

  const getDealSetting = async (filter) => {
    try {
      const response = await get(filter);

      state.dealSetting = response?.data?.data;

      return response;
    } catch (error) {
      console.error(error);

      throw error;
    }
  };

  const postDealSetting = async (dealSetting, options) => {
    const response = await post(dealSetting, options);

    return response;
  };

  const putDealSetting = async (dealSetting, options) => {
    const response = await put(dealSetting, options);

    return response;
  };

  const putDealSettingStatus = async (dealSetting) => {
    const response = await putStatus(dealSetting);

    return response;
  };

  const reset = () => {
    Object.assign(state, getInitialState());
  };

  return {
    dealSettingFormState,
    toggleDealSettingForm,

    toggleActivityLogsDrawer,

    ...toRefs(state),

    getDealSetting,
    postDealSetting,
    putDealSetting,
    putDealSettingStatus,

    reset,
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useDealSettingStore, import.meta.hot));
}
